module.exports = __webpack_public_path__ + "static/img/materialsax01.508bda4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsax01.png
// module id = HBJT
// module chunks = 2